import React from "react";
import "../../styles/registration.css";
import banner from "../../assets/Asset-025.png";
import { useNavigate } from "react-router-dom";


const Banner = () => {
     const navigate = useNavigate();

  return (
    <section className="banner-section mb-5">
      {/* The main card container */}
      <div className="banner-card">
        
        {/* LEFT SIDE: Content */}
        <div className="banner-content">
          <h2 className="banner-title">
            From Classrooms to Careers We Build Futures.
          </h2>
          
          <div className="highlight-wrapper">
            <span className="highlight-text">Learn Today. Lead Tomorrow.</span>
          </div>
          
          <button className="register-btn"  onClick={() => navigate("/contact")}>Register Now</button>
        </div>

        {/* RIGHT SIDE: Image */}
        <div className="banner-image-container">
          {/* Yellow decorative circle behind the image */}
          <div className="yellow-circle"></div>
          
          <img 
            src={banner} 
            alt="Students" 
            className="banner-img"
          />
        </div>

      </div>
    </section>
  );
};

export default Banner;